import FullLayout from 'layout/FullLayout';
import ContactMap from '../../components/Contact/ContactMap';
import ContactInfo from '../../components/Contact/ContactInfo';

const Contact = () => {
  return (
    <FullLayout>
      <div className="w-full min-h-[calc(100vh-80px)] relative grid xl:grid-cols-12 grid-cols-1 gap-8 lg:gap-12 items-stretch py-8 md:py-12 2xl:px-[120px] xl:px-[60px] px-4 md:px-8 overflow-hidden">
        {/* Dekorasi Background Mobile */}
        <div className="absolute top-0 left-0 w-full z-0 xl:hidden pointer-events-none opacity-40">
          <img
            className="h-[150px] w-full object-cover"
            src="kin/assest/bg-contact-top.png"
            alt="kin-frame"
          />
        </div>

        {/* Kolom Kiri: Peta (Mengambil 5 dari 12 kolom desktop) */}
        <div className="xl:col-span-5 w-full flex flex-col justify-center z-10">
          <ContactMap />
        </div>

        {/* Kolom Kanan: Info & Form (Mengambil 7 dari 12 kolom desktop) */}
        <div className="xl:col-span-7 w-full flex items-center z-10">
          <ContactInfo headline="Find Us" />
        </div>
      </div>
    </FullLayout>
  );
};

export default Contact;
